import { Breadcrumbs } from 'shared/page/Breadcrumbs';

import type { Filters, HotelPageState, PlaceRef, SearchConfig } from '@/interfaces';
import { extractNameFromKey } from '@/utils/kayakKeys';
import { filtersToResultPageBrowserQueryParams } from '@/utils/url/resultPageQueryParams';
import { filtersToHotelPageBrowserQueryParams } from '@/utils/url/hotelPageQueryParams';
import type { ExtraHotelData } from '@/server/integration/extraHotelDataResponseTypes';

export interface HotelBreadcrumbProps {
    place: Pick<PlaceRef, 'name'> & Partial<PlaceRef>;
    searchConfig?: SearchConfig;
    hotel?: Pick<HotelPageState, 'name' | 'hotelKey'>;
    filters?: Filters;
    extraHotelData?: Pick<ExtraHotelData, 'name'>;
    subpageTitle?: string;
}

export const HotelBreadcrumbs = ({ place, searchConfig, hotel, filters, extraHotelData, subpageTitle }: HotelBreadcrumbProps) => {
    const placeName = searchConfig?.title ? searchConfig.title : `Hotell i ${place?.name === '-' ? 'kartutsnitt' : place?.name}`;
    const placeKey = place && extractNameFromKey(place.key);
    const resultPageParams = placeKey && hotel && filters && filtersToResultPageBrowserQueryParams(filters, false);
    const resultPageUrl = resultPageParams && `/reise/hotell/resultat/${placeKey}/?${resultPageParams}`;

    const hotelName = extraHotelData?.name || hotel?.name;
    const hotelKey = hotelName && extractNameFromKey(hotel?.hotelKey);
    const hotelPageParams =
        resultPageParams && hotelName && hotelKey && subpageTitle && filters && filtersToHotelPageBrowserQueryParams(filters);
    const hotelUrl = hotelPageParams && `/reise/hotell/detaljer/${hotelKey}/?${hotelPageParams}`;

    return (
        <Breadcrumbs
            items={[
                { title: 'Reise', url: '/reise/' },
                { title: placeName, url: resultPageUrl },
                ...(hotelName ? [{ title: hotelName, url: hotelUrl }] : []),
                ...(subpageTitle ? [{ title: subpageTitle }] : []),
            ]}
        />
    );
};
